import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Subscriptions.css";

import AdminLayout from "../../layouts/AdminLayout";

import { getPlans, deletePlan } from "../../services/subscriptionService";

export default function Subscriptions() {
  const [plans, setPlans] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("All");
  // const [sortBy, setSortBy] = useState("default");

  const navigate = useNavigate();

  useEffect(() => {
    loadPlans();
  }, []);

  const loadPlans = async () => {
    try {
      const data = await getPlans();

      setPlans(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this plan?",
      );

      if (!confirmDelete) return;

      await deletePlan(id);

      alert("Plan Deleted Successfully");

      loadPlans();
    } catch (error) {
      console.error(error);
    }
  };

  const filteredPlans = plans.filter((plan) => {
    const searchMatch =
      plan.planName.toLowerCase().includes(search.toLowerCase()) ||
      plan.duration.toLowerCase().includes(search.toLowerCase());

    const filterMatch = filter === "All" || plan.planName === filter;

    return searchMatch && filterMatch;
  });

  return (
    <AdminLayout>
      <div className="main-conatiner">
        <div className="subscription-header">
          <div className="subscription-header-content">
            <span className="header-badge">Subscription Management</span>

            <h1>Subscription Plans</h1>

            <p>
              Manage pricing, duration, features and limits for all gym
              subscription plans.
            </p>
          </div>

          <button
            className="add-plan-btn"
            onClick={() => navigate("/admin/subscriptions/add")}
          >
            + Add New Plan
          </button>
        </div>

        <div className="subscription-toolbar">
          <input
            type="text"
            placeholder="Search Plans..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="plan-search"
          />

          <div className="plan-filters">
            {["All", "Basic", "Standard", "Premium"].map((item) => (
              <button
                key={item}
                className={filter === item ? "active-filter" : ""}
                onClick={() => setFilter(item)}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        <div className="plans-stats">
          <div className="plan-stat-card">
            <h4>Total Plans</h4>
            <h2>{plans.length}</h2>
          </div>

          <div className="plan-stat-card basic">
            <h4>Basic</h4>
            <h2>{plans.filter((p) => p.planName === "Basic").length}</h2>
          </div>

          <div className="plan-stat-card standard">
            <h4>Standard</h4>
            <h2>{plans.filter((p) => p.planName === "Standard").length}</h2>
          </div>

          <div className="plan-stat-card premium">
            <h4>Premium</h4>
            <h2>{plans.filter((p) => p.planName === "Premium").length}</h2>
          </div>

          <div className="plan-stat-card revenue">
            <h4>Highest Price</h4>

            <h2>
              ₹
              {plans.length
                ? Math.max(...plans.map((p) => Number(p.price)))
                : 0}
            </h2>
          </div>
        </div>
        <div className="subscription-table-wrapper">
          <div className="plans-grid">
            {filteredPlans.map((plan) => (
              <div
                className={`admin-plan-card ${plan.planName.toLowerCase()}`}
                key={plan.id}
              >
                <div className="plan-top">
                  <h2>{plan.planName}</h2>

                  <span>{plan.duration}</span>
                </div>

                <div className="admin-price">
                  ₹{Number(plan.price).toLocaleString("en-IN")}
                </div>

                <div className="limits">
                  <p>
                    <strong>Members</strong>

                    {plan.features?.memberLimit >= 9999
                      ? "Unlimited"
                      : plan.features?.memberLimit}
                  </p>

                  <p>
                    <strong>Trainers</strong>

                    {plan.features?.trainerLimit >= 9999
                      ? "Unlimited"
                      : plan.features?.trainerLimit}
                  </p>

                  <p>
                    <strong>Storage</strong>

                    {plan.features?.storageLimit >= 9999
                      ? "Unlimited"
                      : `${plan.features?.storageLimit} MB`}
                  </p>
                </div>

                <div className="feature-list">
                  {plan.features?.attendance && <span>Attendance</span>}

                  {plan.features?.membershipPlans && <span>Membership</span>}

                  {plan.features?.payments && <span>Payments</span>}

                  {plan.features?.trainers && <span>Trainers</span>}

                  {plan.features?.reports && <span>Reports</span>}

                  {plan.features?.qrScanner && <span>QR</span>}

                  {plan.features?.memberPortal && <span>Portal</span>}

                  {plan.features?.dietPlan && <span>Diet</span>}

                  {plan.features?.aiWorkout && <span>AI</span>}

                  {plan.features?.customerSupport && <span>Support</span>}
                </div>

                <div className="plan-actions">
                  {/* <button
                    className="edit-btn"
                    onClick={() =>
                      navigate(`/admin/subscriptions/edit/${plan.id}`)
                    }
                  >
                    Edit
                  </button> */}

                  <button
                    className="delete-btn"
                    onClick={() => handleDelete(plan.id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
